import {
  ArrowUp,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  CornerUpLeft,
  Home,
} from 'lucide-react';
import { Button } from '@/components/ui/button';

/** Android keycodes sent via `adb shell input keyevent <code>`. */
export const KEYCODE = {
  UP: 19,
  DOWN: 20,
  LEFT: 21,
  RIGHT: 22,
  SELECT: 23,
  BACK: 4,
  HOME: 3,
} as const;

export function DPad({
  onPress,
  disabled,
}: {
  /** screenshot = capture after the key (Select/Back/Home); arrows pass false. */
  onPress: (keycode: number, label: string, screenshot: boolean) => void;
  disabled?: boolean;
}) {
  const press =
    (keycode: number, label: string, screenshot: boolean) => () =>
      onPress(keycode, label, screenshot);

  return (
    <div className="flex flex-col items-center gap-3">
      <div className="grid grid-cols-3 gap-1">
        <span />
        <Button
          variant="outline"
          size="icon"
          disabled={disabled}
          aria-label="Up"
          onClick={press(KEYCODE.UP, 'Up', false)}
        >
          <ArrowUp className="h-4 w-4" />
        </Button>
        <span />

        <Button
          variant="outline"
          size="icon"
          disabled={disabled}
          aria-label="Left"
          onClick={press(KEYCODE.LEFT, 'Left', false)}
        >
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <Button
          size="icon"
          disabled={disabled}
          aria-label="Select"
          onClick={press(KEYCODE.SELECT, 'Select', true)}
        >
          OK
        </Button>
        <Button
          variant="outline"
          size="icon"
          disabled={disabled}
          aria-label="Right"
          onClick={press(KEYCODE.RIGHT, 'Right', false)}
        >
          <ArrowRight className="h-4 w-4" />
        </Button>

        <span />
        <Button
          variant="outline"
          size="icon"
          disabled={disabled}
          aria-label="Down"
          onClick={press(KEYCODE.DOWN, 'Down', false)}
        >
          <ArrowDown className="h-4 w-4" />
        </Button>
        <span />
      </div>

      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          disabled={disabled}
          onClick={press(KEYCODE.BACK, 'Back', true)}
        >
          <CornerUpLeft className="mr-1 h-4 w-4" />
          Back
        </Button>
        <Button
          variant="outline"
          size="sm"
          disabled={disabled}
          onClick={press(KEYCODE.HOME, 'Home', true)}
        >
          <Home className="mr-1 h-4 w-4" />
          Home
        </Button>
      </div>
    </div>
  );
}
